import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { nomService } from '../../services/api/nom.service';
import { reportService } from '../../services/api/report.service';
import { utils } from "../../services/helpers/utils";

export const PatientMMPreauthorizations = ({ cnp, activeComponent, searchCode }) => {
    const [preautorizari, setPreautorizari] = useState([]);
    const navigate = useNavigate();
    const partener = sessionStorage.getItem('idPartener');

    useEffect(() => {
        if (cnp) {
            nomService.getPreauthorizationMM({code: cnp, partener: partener })
                .then(response => {
                    if (response) {
                        setPreautorizari(response);
                    }
                    else {
                        setPreautorizari(null);
                    }
                });
        }
    }, [cnp]);

    const handleView = (page, param, value) => {

        var encode = {
            cnp: searchCode ?? cnp,
            activeComponent: activeComponent
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${param}=${value}`);
    }

    const handleExport = () => {
        reportService.RaportCautarePacientPreautorizariMM({ Code: cnp, Partener: 0 }).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }

    return (
        <>
            {
                preautorizari &&
                <>
                    <p className="paragraf">Preautorizari anterioare MM:</p>
                    <table className="tbl" data-name="lista" width="100%">
                        <thead>
                            <tr>
                                <th>Nr</th>
                                <th>Companie</th>
                                <th>Abonament</th>
                                <th>Tip fisa</th>
                                <th>Status</th>
                                <th>Adaugat la</th>
                                <th>Partener</th>
                                <th className="tac">Vezi preautorizare</th>
                            </tr>
                        </thead>
                        <tbody>
                            {preautorizari.map((preautorizare, index) => (
                                <tr key={index}>
                                    <td data-name="nr_crt" className="center">{index + 1}</td>
                                    <td data-name="nume_firma">{preautorizare.denumireFirma}</td>
                                    <td data-name="nume_profil">
                                        {preautorizare.denumireProfil}
                                        {preautorizare.firmaMaster && <span> (</span>}
                                        {preautorizare.firmaMaster}
                                        {preautorizare.firmaMaster && <span>)</span>}
                                    </td>
                                    <td data-name="tip_fisa">{preautorizare.tipFisa}</td>
                                    <td data-name="status" className="center">{preautorizare.status}</td>
                                    <td data-name="adaugat_la" className="center">{preautorizare.adaugatLa}</td>
                                    <td data-name="partener" className="center">{preautorizare.numePartener}</td>
                                    <td>
                                        <a className="icon deschide m0auto"
                                            onClick={() => handleView("preautorizare-mm", "id", preautorizare.idPreautorizare)}
                                            title="Vezi preautorizare" data-name="view">Vizualizare</a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div data-name="export">
                        <button data-name="btn-export" className="btn" onClick={handleExport}>Export</button>
                    </div>
                </>
            }
        </>
    );
};